module.exports = __webpack_public_path__ + "img/PT5340.3ded44c0.svg";